module.exports = {"620422100":"会师镇","620422101":"郭城驿镇","620422102":"河畔镇","620422103":"头寨子镇","620422104":"太平店镇","620422105":"甘沟驿镇","620422106":"侯家川镇","620422107":"柴家门镇","620422108":"汉家岔镇","620422109":"刘家寨子镇","620422110":"白草塬镇","620422111":"大沟镇","620422112":"四房吴镇","620422113":"中川镇","620422114":"老君坡镇","620422115":"平头川镇","620422116":"丁家沟镇","620422117":"杨崖集镇","620422118":"翟家所镇","620422119":"韩家集镇","620422120":"土门岘镇","620422121":"新塬镇","620422122":"草滩镇","620422123":"新庄镇","620422202":"新添堡回族乡","620422204":"党家岘乡","620422213":"八里湾乡","620422225":"土高山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620422.json
// module id = 3044
// module chunks = 0